"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BranchEndCommand = void 0;
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
/**
 * Begins a normal song notation without branching. Retains the visual branch
 * from previous #BRANCHSTART.
 */
class BranchEndCommand extends Command_1.Command {
    constructor() {
        super(CommandType_1.CommandType.BranchEnd);
    }
    static parse(_args) {
        return new BranchEndCommand();
    }
}
exports.BranchEndCommand = BranchEndCommand;
